import { DialogTitle, Box, Typography, IconButton, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

interface DialogHeaderProps {
  title: string;
  onClose: () => void;
  disabled?: boolean;
  onBack?: () => void;
}

export const DialogHeader = ({ title, onClose, disabled = false, onBack }: DialogHeaderProps) => (
  <>
    <DialogTitle sx={{ pb: 1 }}>
      <Box sx={{ position: 'relative' }}>
        {onBack && (
          <IconButton
            onClick={onBack}
            disabled={disabled}
            size="small"
            sx={{ position: 'absolute', left: 0, top: '50%', transform: 'translateY(-50%)' }}
          >
            <ArrowBackIcon />
          </IconButton>
        )}
        <Typography variant="h6" component="div" align="center">
          {title}
        </Typography>
        <IconButton
          onClick={onClose}
          disabled={disabled}
          size="small"
          sx={{ position: 'absolute', right: 0, top: '50%', transform: 'translateY(-50%)' }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
    </DialogTitle>
    <Divider />
  </>
);
